import { useTranslation } from "react-i18next";
import { usePreference } from "../../../context/usePreference";

import i18n from "../../../i18n";

const DateNavBar = ({ user }) => {
  const { userPreference, userTarget } = usePreference();
  const { t } = useTranslation();

  let targetId = userTarget?.Target?.Id;
  const Target = userPreference.Praca?.Targets?.find(
    (target) => target.Id === targetId
  ) ?? userPreference.Praca?.Targets?.[0];
  
  let day, month, year;
    if (!user?.userPreference?.ChangeAutoUpdate) {
      let dateInv = userPreference.Data.split('T')[0].split('-');
      day = dateInv[2];
      month = dateInv[1];
      year = dateInv[0];
  } else {
      let horarioDate = userPreference.Horario.split('T')[0].split('-');
      day = horarioDate[2];
      month = horarioDate[1];
      year = horarioDate[0];
  }
  let currentDate = ""

  if ((i18n?.language?.toUpperCase() == "EN-US")) {
     currentDate = `${month}-${day}-${year}`;
  } else {
     currentDate = `${day}-${month}-${year}`;
  }

  return (
    <div className="divDate" style={{ backgroundColor: user?.userPreference?.Target.FatorCor }}>
      <div className="divDateText">{t("rows.date")} : <span translate="no">{currentDate}</span></div>
      <div style={{ float: 'right', color: 'white', paddingRight: '10px' }}>{Target?.Desc}</div>
      <div style={{ float: 'left', color: 'white', paddingRight: '10px' }}>{user?.userPreference?.Target.FatorDesc}</div>
    </div>
  )
}

export default DateNavBar;